import React, { useMemo } from 'react';
import { NOT_SUPPORTED_WALLETS_LINKS, WALLET_KEYS_TO_NAME } from '../../constants/wallet';
import { getWalletIcon } from '../../services/providerService';

interface ISuggestions {
  browserName: string
  mobile?: boolean,
}

const Suggestions: React.FC<ISuggestions> = ({ browserName, mobile }) => {
  const links = useMemo(() => (mobile ? NOT_SUPPORTED_WALLETS_LINKS.mobile : NOT_SUPPORTED_WALLETS_LINKS.browser), [mobile]);
  console.log('Suggestions', links, browserName);
  return (
    <div className="web3-wc_suggestions-wrapper">
      {Object.keys(links).map((walletName) => {
        const walletData = useMemo(() => links[walletName], [walletName]);
        const walletLabel = useMemo(() => WALLET_KEYS_TO_NAME[walletName], [walletName]);
        const Icon = useMemo(() => getWalletIcon(walletLabel), [walletLabel]);

        if (!walletData[browserName]) return null;

        return (
          <div key={walletName} className="web3-wc_nowallet-wrapper">
            <div className="web3-wc_icon-name-wrapper">
              <Icon />
              <div className="web3-wc_name">{walletLabel}</div>
            </div>

            <ul className="web3-wc_options-wrapper">
              <li className="web3-wc_option">
                <a
                  className="web3-wc_option-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={walletData[browserName]}
                >
                  {walletData[browserName]}
                </a>
              </li>
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default Suggestions;